import {
  Code2,
  MonitorSmartphone,
  Server,
  Layers,
  Smartphone,
  ClipboardCheck,
  PenTool,
  Cloud,
  BarChart3,
  Users,
  UserPlus,
  FolderKanban,
  TrendingUp,
  Cpu,
  Workflow,
  Target,
  Rocket,
  Globe2,
  Building2,
  Store,
  Boxes,
  Sparkles,
  ShieldCheck,
  Palette,
} from "lucide-react";

export const STAFFING_CAPABILITIES = [
  { icon: Code2, title: "Software Developers" },
  { icon: MonitorSmartphone, title: "Frontend Developers" },
  { icon: Server, title: "Backend Developers" },
  { icon: Layers, title: "Full-Stack Developers" },
  { icon: Smartphone, title: "Mobile App Developers" },
  { icon: ClipboardCheck, title: "QA / Test Engineers" },
  { icon: PenTool, title: "UI/UX Designers" },
  { icon: Cloud, title: "DevOps / Cloud Engineers" },
  { icon: BarChart3, title: "Business Analysts" },
  { icon: Users, title: "Project / Product Resources" },
];

export const ENGAGEMENT_MODELS = [
  {
    icon: UserPlus,
    title: "Dedicated Resources",
    desc: "Dedicated professionals working as an extension of your team.",
  },
  {
    icon: Users,
    title: "Dedicated Development Team",
    desc: "A coordinated team assembled around a specific product or project.",
  },
  {
    icon: FolderKanban,
    title: "Project-Based Staffing",
    desc: "Technology resources aligned to defined project requirements and timelines.",
  },
  {
    icon: TrendingUp,
    title: "Flexible Scaling",
    desc: "Scale technology capacity up or down based on business requirements.",
  },
];

export const WHY_STAFFING = [
  {
    icon: Cpu,
    title: "Technology-Focused Talent",
    desc: "Resources aligned with software and digital product development.",
  },
  {
    icon: TrendingUp,
    title: "Flexible Team Scaling",
    desc: "Add or adjust technology capacity based on project needs.",
  },
  {
    icon: Workflow,
    title: "Integrated Collaboration",
    desc: "Resources work within your existing processes and tools.",
  },
  {
    icon: Target,
    title: "Quality & Technical Alignment",
    desc: "Focus on matching technical capabilities with project requirements.",
  },
  {
    icon: Rocket,
    title: "Business-Focused Delivery",
    desc: "Staffing aligned with actual delivery objectives — not simply filling positions.",
  },
];

export const STAFFING_PROCESS = [
  { step: "01", title: "Understand Your Requirements", desc: "We start with your goals, team structure and the skills you actually need." },
  { step: "02", title: "Identify the Right Talent", desc: "We shortlist technology professionals matched to your technical requirements." },
  { step: "03", title: "Interview & Select", desc: "You interview and choose the people who fit your team and ways of working." },
  { step: "04", title: "Onboard & Collaborate", desc: "Your new team members integrate into your tools, rituals and roadmap." },
  { step: "05", title: "Scale When Needed", desc: "Add or adjust capacity as your product and business evolve." },
];

export const TECH_AREAS = [
  { icon: Globe2, title: "Web Development", tags: "Frontend • Backend • Full Stack" },
  { icon: Smartphone, title: "Mobile Development", tags: "iOS • Android • Cross Platform" },
  { icon: Cloud, title: "Cloud & DevOps", tags: "Cloud • CI/CD • Infrastructure Automation" },
  { icon: Sparkles, title: "Data & AI", tags: "AI Applications • Data Solutions • Automation" },
  { icon: ShieldCheck, title: "Quality Engineering", tags: "Manual Testing • Automation Testing • QA" },
  { icon: Palette, title: "Design", tags: "UI/UX • Product Design" },
];

export const STAFFING_AUDIENCES = [
  { icon: Rocket, title: "Startups" },
  { icon: TrendingUp, title: "Growing Businesses" },
  { icon: Boxes, title: "Product Companies" },
  { icon: Users, title: "Technology Teams" },
  { icon: Store, title: "Businesses Launching New Digital Products" },
];

export const TEAM_CHIPS = ["Frontend Dev", "Backend Dev", "QA Engineer", "UI/UX Designer", "DevOps"];
